<template>
	
	<v-dialog
	    v-model="visible"
		persistent
	    width="500"
		class="edit-dialog"
		ref="editDialog"
		eager
	>
		<v-card>
			<v-card-title class="text-subtitle-1 white--text info" color="darkseagreen" ref="editDialogTitle">
				{{title}}
			</v-card-title>
			<v-card-text  class="mx-0 px-0 my-1">
				
                <div class="form-item form-item-width-1 pt-2 ma-0">
                    <label class="form-item-label py-0 mt-0 mr-0">人员编号:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense
                        placeholder=""
                        readonly							
                        v-model="editing.userId"
                    >
                    </v-text-field>						
                </div>
				
                <div class="d-flex flex-row">
                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">姓名:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0 readonly_input_item" 								
                            outlined
                            dense
                            placeholder=""
                            readonly							
                            v-model="editing.userName"
                        >
                        </v-text-field>						
                    </div>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">手机号码:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0 readonly_input_item" 								
                            outlined
                            dense
                            placeholder=""
                            readonly							
                            :value="editing.mobile"
                            v-model="editing.mobile"
                        >
                        </v-text-field>						
                    </div>
                </div>

                <v-divider class="my-1" />

                <div class="form-item form-item-width-2 pt-2 ma-0">
                    <label class="form-item-label py-0 mt-0 mr-0">任职部门:</label>
 
                    <DepartmentSelector	
                        class="form-item-value py-0 mr-0" 	
                        v-model="selectedDepartments"
                        :items="departments"
                        item-text="name"
                        item-value="id"
                        item-children="lower"
                        :outlined="true"
                        :dense="true"
                        selectionType="2"
                        :multiSelect="false"
                    />		
                </div>

                <div class="form-item form-item-width-1 pt-2 ma-0">
                    <label class="form-item-label py-0 mt-0 mr-0">任职级别:</label>
                    <v-select
                        class="form-item-value py-0 mr-0" 	
                        v-model="editing.positionLevel"
                        :items="positionLevels"						
                        label=""
                        hide-details											
                        flat
                        solo
                        outlined
                        dense						                            
                        item-text="name"
                        item-value="id"
                        full-width						
                    >
                    </v-select>					
                </div>

                <div class="form-item form-item-width-1 pt-2 ma-0">
                    <label class="form-item-label py-0 mt-0 mr-0">任职类型:</label>
                    <v-select
                        class="form-item-value py-0 mr-0" 	
                        v-model="editing.positionType"
                        :items="positionTypes"						
                        label=""
                        hide-details											
                        flat
                        solo
                        outlined
                        dense						                            
                        item-text="name"
                        item-value="id"
                        full-width						
                    >
                    </v-select>					
                </div>

                
                <v-radio-group v-model="editing.mainFlag">
                    <div class="d-flex flex-row">
                        <label class="form-item-label py-0 mt-0 mr-0"></label>
                        <div>
                        <v-radio
                            label="主职"
                            value="1"
                        ></v-radio>
                        </div>
                        <div>
                        <v-radio
                            label="兼职"
                            value="0"
                        ></v-radio>
                        </div>
                    </div>
                </v-radio-group>
                
				
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  
			  <v-btn
				color="success"
				class="left-round"
				@click="handleSave"
			  >			
                <span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>	
				保存
				
			  </v-btn>

              <v-btn
				color="blue-grey"
				class="right-round"
				@click="cancelClicked"
			  >
				
				取消
                <span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
			  </v-btn>

			</v-card-actions>
		</v-card>
	</v-dialog>
	
</template>

<script>

    import DragSupport from '../../../../util/drag.js';
    import PositionLevelApi from '../../../../api/smp/org/PositionLevelApi.js';
    import PositionTypeApi from '../../../../api/smp/org/PositionTypeApi.js';
    import AppointApi from '../../../../api/smp/org/AppointApi.js';
    import DepartmentApi from "../../../../api/smp/org/DepartmentApi.js";

    //import DepartmentSelector from "./DepartmentSelector.vue";
    import DepartmentSelector from "../../../../components/common/tree/combo/ComboTree.vue";
    //import DepartmentSelector from "../../../../components/common/tree/selector/TreeSelector.vue";
	 
	export default {
		name: 'AppointEditDialog',
		components: {
            "DepartmentSelector":DepartmentSelector,
		},
		data: () => ({
			visible:false,
			mode:0, //1新增2编辑
            
            editing:{
                userId:'',
                userName:'',
                mobile:'',
                deptId:'',
                deptName:'',
                orgId:'',
                orgName:'',
                mainFlag:0,
                positionLevel:"99",
                positionType:"99"
            },

            selectedDepartments:[],
			positionLevels:[],
            positionTypes:[],
            departments:[],
            options:null,
		}),
		methods:{
			async errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			async  infoMsg(title,text){
				await this.$dialog.info({
					text: text,
					title: title
				});
			},
			setVisible(v){
                this.visible=v;
                let dialogEl = this.$refs.editDialog.$refs.dialog;
                
				if(this.visible==true)
					DragSupport.bind(dialogEl,this.$refs.editDialogTitle);
				else
					DragSupport.unbind(dialogEl);    
			},
			setMode(m){
				this.mode=m;
            },
            setOptions(options){
                this.options = options;
            },
			setNewAppointEditing(userId,userName,mobile){
                this.editing.userId = userId;
                this.editing.userName = userName;
                this.editing.mobile = mobile;
                this.editing.positionLevel = "99";
                this.editing.positionType = "99";
                this.editing.deptId='';
                this.editing.deptName='';
                this.editing.orgId='';
                this.editing.orgName=''; 
                this.editing.mainFlag='1';

                this.selectedDepartments = [];
            },
			clear(){
				
            },
            cancelClicked(){
                this.clear();
                this.setVisible(false);
            },
			handleSave(){
				let me = this;
				if((!this.editing.deptId)||(this.editing.deptId=='')){
					me.errMsg('错误','还没有选择任职部门');
					return;
				}
				if((!this.editing.positionLevel)||(this.editing.positionLevel=='')){
					me.errMsg('错误','还没有选择职位级别');
					return;
				}
				if((!this.editing.positionType)||(this.editing.positionType=='')){
					me.errMsg('错误','还没有选择职位类别');
					return;
				}
				
				let requestData={
					mode:me.mode,
					appoint:{
						userId:me.editing.userId,
						deptId:me.editing.deptId,
						positionLevel:me.editing.positionLevel,
						positionType:me.editing.positionType,
						mainFlag:me.editing.mainFlag
					}
				};
				if(me.mode==1){
					//
				}else if(me.mode==2){
					//
				}else {
					throw new Error("not supported mode");
				}
				
				
				//开始发送请求
				AppointApi.insertAppoint(requestData.appoint).then(function(resp){
					console.log(resp);
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'新增任职信息失败':msg;
						if(data.msg_detail)
							msg = msg +'('+data.msg_detail+')';
						throw new Error(msg);
						return;
					}
					
					let appoint = data.data.appoint;
					console.log("insert appoint finished");
					console.log(appoint);
					me.infoMsg('成功','新任职数据已经保存');
					me.setVisible(false);

					me.$emit("insertAppointFinished",appoint,me.options);
				}).catch(function(err){
					console.log(err.stack);
					console.log(err);
					me.errMsg('错误','保存任职信息可能失败，请刷新数据确认;异常信息:'+err.message);
				});
			},
			loadPositionTypes(){
				let me = this;
				PositionTypeApi.queryPositionType().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取职位类别失败':msg;
						throw new Error(msg);
						return;
					}

					let positionTypes = data.data.positionTypes;
					console.log("request positionTypes returned:");
					console.log(positionTypes);
					me.positionTypes = positionTypes;
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取职位类别失败:'+err.message);
				});
            },
            loadPositionLevels(){
				let me = this;
				PositionLevelApi.queryPositionLevel().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取职位级别失败':msg;
						throw new Error(msg);
						return;
					}

					let positionLevels = data.data.positionLevels;
					console.log("request positionLevels returned:");
					console.log(positionLevels);
					me.positionLevels = positionLevels
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取职位级别失败:'+err.message);
				});
            },
            loadDepartments(){
				let me = this;
				DepartmentApi.queryAllDepartmentTree().then(function(resp){
					let data = resp.data;

					if((!data)||(!(data.code))||(data.code!=200)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取部门信息失败':msg;
						throw new Error(msg);
						return;
					}
					if((!data.data)||(!data.data.departments)){
						throw new Error('获取部门信息失败(无部门数据)');
						return;
					}
					
					me.departments = data.data.departments;
					//me.levelDepartments(departments,1,null);
					//me.departments = departments;
					
					//me.collectVisibleDepartments();
				}).catch(function(err){
					me.errMsg('错误','获取部门信息失败:'+err.message);
				});
            },
            selectionCheck(item){
                if(item && item.code && item.code.length && item.code.length>8)
                    return true;
                return false;
            }
		},
		computed:{
			title(){
				if(this.mode==1)
					return "增加任职";
				else if(this.mode==2)
					return "编辑任职";
				else
					return "未知操作";			
			}
        },
        watch:{
            selectedDepartments:function(newVal){
                if(!newVal || newVal.length<1)
                    this.editing.deptId = "";
                else
                    this.editing.deptId = newVal[0];
            }
        },
		mounted(){
			this.loadPositionTypes();
            this.loadPositionLevels();
            this.loadDepartments();
		}
	}
</script>

<style scoped>
	.edit-dialog{
		border-radius: 4px;
	}
	.readonly_input_item{
		background-color:lightgray;
	}
	.careful_input_item{
		background-color:lightblue;
	}
</style>
